import { Injectable, Inject } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class MemberService {
  myAppUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  GetSession() {
    return this._http.get(this.myAppUrl + 'api/Masters/GetSession')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           MEMBER      -------------

  FillMemberExplorer(FDate: string, TDate: string, Status: number) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberExplorer/' + FDate + '/' + TDate + '/' + Status)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  FillHomeData(UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillHomeData/' + UserId + '/' + UserType +'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  MemberActivate(MemberId: string, EpinSrno: string, Epin: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/MemberActivate/' + MemberId + '/' + EpinSrno + '/' + Epin + '/' + UserId + '/' + UserType +'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  SaveMemberRequest(UserId: number, UserType: string,PackageId: string,RequestType: string,PaymodeId: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/SaveMemberRequest/' + UserId + '/' + UserType + '/' + PackageId + '/' + RequestType + '/' + PaymodeId + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillLeftSideTeamList(FDate: string, TDate: string, Status: number, OnlyDirect: number, MemberId:number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillLeftSideTeamList/' + FDate + '/' + TDate + '/' + Status + '/' + OnlyDirect + '/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillRightSideTeamList(FDate: string, TDate: string, Status: number, OnlyDirect: number, MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillRightSideTeamList/' + FDate + '/' + TDate + '/' + Status + '/' + OnlyDirect + '/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  // City --------------- City ------------------------------

  FillCity(StateId:number) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetCity/'+StateId)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //-----------                           STATE      -------------
  FillState() {
    return this._http.get(this.myAppUrl + 'api/Masters/FillState')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  //-----------                           BANK      -------------
  FillBank() {
    return this._http.get(this.myAppUrl + 'api/Masters/FillBank')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           BANK      -------------
  FillEPinPackage() {
    return this._http.get(this.myAppUrl + 'api/Masters/FillEPinPackage')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

   //-----------                           BANK      -------------
  GetPlanToBeRenew(UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetPlanToBeRenew/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           BANK      -------------
  GetPlanToBeUpgrade(UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetPlanToBeUpgrade/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           BANK      -------------
  GetAvailablePin(PackageId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetAvaiablePin/' + PackageId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           BANK      -------------
  GetMemberName(Code: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetMemberName/' + Code)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           BANK      -------------
  GetWithrawalRequestMemberDetails(Id: number) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetWithrawalRequestMemberDetails/' + Id)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           BANK      -------------
  GetMemberTreeDetail(Id: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetMemberTreeDetail/' + Id)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           Users      -------------
  UpdateMemberProfile(
              UserId: number,
              UserName: string,
              ContactNo: string,
              Email: string,
              PAN: string,
              Aadhar: string,
              Gender: string,
              NomineeName: string,
              NomineeRelation: string,
              Bank: number,
              AcHolderName: string,
              IFSCode: string,
              Accountno: string,
              Address: string,
              State: number,
              City: number,
              UserType: string,
  ) {

    debugger;
    return this._http.get(this.myAppUrl + 'api/Masters/UpdateMemberProfile/' +
      UserId + '/' +
      UserName + '/' +
      ContactNo + '/' +
      Email + '/' +
      PAN + '/' +
      Aadhar + '/' +
      Gender + '/' +
      NomineeName + '/' +
      NomineeRelation + '/' +
      Bank + '/' +
      AcHolderName + '/' +
      IFSCode + '/' +
      Accountno + '/' +
      Address + '/' +
      State + '/' +
      City + '/' +
      UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //////////////////

  FillEPinStatus(UserId: number, UserType:string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillEPinStatus/'+UserId+'/'+UserType+'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  FillEPinReceiveTransfer(UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillEPinReceiveTransfer/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  GetPackageEPin(PackageId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetPackageEPin/' + PackageId +'/'+UserId+'/'+UserType+'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GenerateEPIN(PackageId: number,GenerateEpin: string, UserId: number
  ) {
    return this._http.get(this.myAppUrl + 'api/Masters/GenerateEPIN/' + PackageId + '/' + GenerateEpin + '/' + UserId)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  TransferEPIN(FromMembreId: number, ToMemberId: number, PackageId: number, NoOfEPin: string, UserType: string)
  {
    return this._http.get(this.myAppUrl + 'api/Masters/TransferEPIN/' + FromMembreId + '/' + ToMemberId + '/' + PackageId + '/' + NoOfEPin + '/' + UserType+'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  SaveDonationSlip(FromMembreId: number, ToMemberId: number, PackageId: number, DonationAmount: string, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/SaveDonationSlip/' + FromMembreId + '/' + ToMemberId + '/' + PackageId + '/' + DonationAmount + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  SaveDonationSlipOnWR(WithdrawalId: number, FromMembreId: number, ToMemberId: number, DonationAmount: string, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/SaveDonationSlipOnWR/' + WithdrawalId + '/' + FromMembreId + '/' + ToMemberId + '/' + DonationAmount + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  ChangePassword(
    OldPassword: string,
    NewPassword: string,
    ConfirmPassword: string, UserId: number, UserType: string
  ) {
    return this._http.get(this.myAppUrl + 'api/Masters/ChangePassword/' + OldPassword + '/' + NewPassword + '/' + ConfirmPassword +'/ '+UserId+' / '+UserType)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  MemberChangePassword(
    MemberId: number,
    OldPassword: string,
    NewPassword: string,
    ConfirmPassword: string
  ) {
    return this._http.get(this.myAppUrl + 'api/Masters/MemberChangePassword/' + MemberId + '/' + NewPassword + '/' + ConfirmPassword + '/' + OldPassword)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  UpdateUserProfile(MemberProfileform){
    return this._http.post(this.myAppUrl + 'api/Masters/UpdateUserProfile', MemberProfileform)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetUserDetail(UserId: number) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetUserDetail/'+UserId)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  
  GetUserIdByUserCode(UserCode: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/GetUserIdByUserCode/'+UserCode)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //-----------                           Relation      -------------
  FillRelation() {
    return this._http.get(this.myAppUrl + 'api/Masters/FillRelation')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                           DirectTree      -------------
  FillSponsorTree(MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillSponsorTree/' + MemberId + '/' + UserId + '/' + UserType +'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillPlan1Tree(MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillPlan1Tree/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillPlan2Tree(MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillPlan2Tree/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillPlan3Tree(MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillPlan3Tree/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillPlan4Tree(MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillPlan4Tree/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillDirectIntroducer(MemberId: number, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillDirectIntroducer/' + MemberId + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  //-----------                            Income      -------------
  FillMatchingIncome(TillDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillMatchingIncome/' + TillDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  FillDirectLevelIncome(FDate: string,TDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillDirectLevelIncome/' + FDate + '/' + TDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillBoosterWallet(FDate: string, TDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillBoosterWallet/' + FDate + '/' + TDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillGOIIncome(FDate: string, TDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillGOIIncome/' + FDate + '/' + TDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  FillTdsReport(FDate: string, TDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillTdsReport/' + FDate + '/' + TDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillSendDonationReport(FDate: string, TDate: string,Status: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillSendDonationReport/' + FDate + '/' + TDate + '/' + Status +'/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillReceiveDonationReport(FDate: string, TDate: string, Status: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillReceiveDonationReport/' + FDate + '/' + TDate + '/' + Status + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillRepurchaseWallet(FDate: string, TDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillRepurchaseWallet/' + FDate + '/' + TDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillGOIIncomeMonthly(FDate: string, TDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillGOIIncomeMonthly/' + FDate + '/' + TDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillCompanyTurnOver(TillDate: string, UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillCompanyTurnOver/' + TillDate + '/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  Payment() {    return this._http.get(this.myAppUrl + 'api/Masters/Payment')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  GOIPayment() {    return this._http.get(this.myAppUrl + 'api/Masters/GOIPayment')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  DeleteTemporaryPaymentToBeDone(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/DeleteTemporaryData/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillWithdrawalHistory(UserId: number, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillWithdrawalHistory?UserId=' + UserId + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  SaveWIthdrawalRequest(Amount: string, UserId: number, UserType: string, WalletType: number) {
    return this._http.get(this.myAppUrl + 'api/Masters/SaveWithdrawalRequest/' + Amount + '/' + UserId + '/' + UserType + '/' + WalletType +'')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  FillMemberWalletBalance(UserId: number, UserType: string) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberWalletBalance/' + UserId + '/' + UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }  FillMemberWalletBalanceType(UserId: number, UserType: string, WalletType: number) {
    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberWalletBalanceType/' + UserId + '/' + UserType + '/' + WalletType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }  ApproveWithdrawalRequest(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/Approve_WithdrawalRequest/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  RejectWithdrawalRequest(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/Reject_WithdrawalRequest/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }  ApproveMemberRegistrationRequest(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/Approve_MemberRegistrationRequest/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  GetDonationSponsorBankDetails(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/GetDonationSponsorBankDetails/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  GetRegistrationAmount(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/GetRegistrationAmount/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  GetUpgradationAmount(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/GetUpgradationAmount/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  SendDonationSlip(PaymodeId: string, DonationSlipId: string) {    return this._http.get(this.myAppUrl + 'api/Masters/SendDonationSlip/' + PaymodeId + '/' + DonationSlipId  + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  ApproveDonation(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/ApproveDonation/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  RejectDonation(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/RejectDonation/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  RejectMemberRegistrationRequest(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/Reject_MemberRegistrationRequest/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }  FillWithdrawalRequest(UserId: number, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillWithdrawalRequest?UserId=' + UserId + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillMemberRegistrationRequest(UserId: number, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberRegistrationRequest?UserId=' + UserId + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillMemberRegistrationRequestHistory(UserId: number, FDate: string,TDate: string, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberRegistrationRequestHistory?UserId=' + UserId + '&FDate=' + FDate + '&TDate=' + TDate + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillDonationSlipToBePaid(UserId: number, UserType: string) {    return this._http.get(this.myAppUrl + 'api/Masters/FillDonationSlipToBePaid?UserId=' + UserId + '&UserType=' + UserType +'')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillMemberRegistrationRenewRequest(UserId: number, UserType: string) {    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberRegistrationRenewRequest?UserId=' + UserId + '&UserType=' + UserType + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillMemberRegistrationUpgradeRequest(UserId: number, UserType: string) {    return this._http.get(this.myAppUrl + 'api/Masters/FillMemberRegistrationUpgradeRequest?UserId=' + UserId + '&UserType=' + UserType + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillDonationSlipToBeReceived(UserId: number, UserType: string) {    return this._http.get(this.myAppUrl + 'api/Masters/FillDonationSlipToBeReceived?UserId=' + UserId + '&UserType=' + UserType + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  EditProfile(
    UserId: number,
    UserName: string,
    Gender: string,
    State: number,
    City: number,
    Address: string,
    ContactNo: string,
    Email: string,
    NomineeName: string,
    NomineeRelation: string,
    UserType: string,
  ) {
   
    return this._http.get(this.myAppUrl + 'api/Masters/EditProfile/' +
      UserId + '/' +
      UserName + '/' +
      Gender + '/' +
      State + '/' +
      City + '/' +
      Address + '/' +
      ContactNo + '/' +
      Email + '/' +
      NomineeName + '/' +
      NomineeRelation + '/' +
      UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }





  UpdateProfilePicture(ImageUpdateform) {
    debugger;
    return this._http.post(this.myAppUrl + 'api/Masters/UpdateProfilePicture', ImageUpdateform)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateDonationSlip(RegRequest, DonationSlipId) {
    debugger;
    return this._http.post(this.myAppUrl + 'api/Masters/UpdateDonationSlip/' + DonationSlipId, RegRequest )
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  UpdateRegistrationSlip(RegRequest, RegistrationSlipId) {
    debugger;
    return this._http.post(this.myAppUrl + 'api/Masters/UpdateRegistrationSlip/' + RegistrationSlipId, RegRequest)
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }






  UpdateBankDetails(
    UserId: number,
    AccountName: string,
    AccountNumber: string,
    Bank: number,
    Branch: number,
    Ifsc: string,
    AccountType: string,
    GooglePayNo: string,
    PhonePayNo: string,
    PaytmNo: string,
    UserType: string,
  ) {
    debugger;
    return this._http.get(this.myAppUrl + 'api/Masters/UpdateBankDetails/' +
      UserId + '/' +
      AccountName + '/' +
      AccountNumber + '/' +
      Bank + '/' +
      Branch + '/' +
      Ifsc + '/' +
      AccountType + '/' +
      GooglePayNo + '/' +
      PhonePayNo + '/' +
      PaytmNo + '/' +
      UserType + '')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }




  DeleteGOITemporaryPaymentToBeDone(Id: string) {    return this._http.get(this.myAppUrl + 'api/Masters/DeleteGOITemporaryData/' + Id + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  GetNews() {
    return this._http.get(this.myAppUrl + 'api/Masters/GetNews')
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

 

  //GetNotification(UserId: number, UserType: string) {  //  return this._http.get(this.myAppUrl + 'api/Masters/GetNotification?UserId=' + UserId + '&UserType=' + UserType + '')  //    .map((response: Response) => response.json())  //    .catch(this.errorHandler);  //}

  FillWalletHistory(UserId: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillWalletHistory/' + UserId + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }  GetNotification(UserId: number, UserType: string) {    return this._http.get(this.myAppUrl + 'api/Masters/GetNotification/' + UserId +'/' + UserType + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }  FillPaymentToBeDone(UserId: number, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillAmountToBePaid?UserId=' + UserId + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '&Type1=' + Type1 + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillGOIPaymentToBeDone(UserId: number, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillGOIAmountToBePaid?UserId=' + UserId + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '&Type1=' + Type1 + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }



  SendSMSGenerateSlip(ContactNo: string, MessageBody: string) {    debugger;    return this._http.get(this.myAppUrl + 'api/Masters/SendSMSGenerateSlip/' + ContactNo + '/' + MessageBody + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillTemporaryPaymentToBeDone() {    return this._http.get(this.myAppUrl + 'api/Masters/FillTemporaryAmountToBePaid')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillGOITemporaryPaymentToBeDone() {    return this._http.get(this.myAppUrl + 'api/Masters/FillGOITemporaryAmountToBePaid')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }

  FillPaymentDone(UserId: number, MemberCode: string, AccountNo: string, Type1: number) {    return this._http.get(this.myAppUrl + 'api/Masters/FillAmountPaid?UserId=' + UserId + '&MemberCode=' + MemberCode + '&AccountNo=' + AccountNo + '&Type1=' + Type1 + '')      .map((response: Response) => response.json())      .catch(this.errorHandler);  }


 


  



  //-----------                            ERROR HANDLER      -------------
  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/Member.service.ts